module.exports = __webpack_public_path__ + "img/transaction_withdraw.5c1af520.svg";